import { BroadcastAffiliationDetail as BroadcastAffiliationDetailComponent } from './BroadcastAffiliationDetail.component';
import { connector } from './BroadcastAffiliationDetail.connector';

export const BroadcastAffiliationDetail = connector(BroadcastAffiliationDetailComponent);
